export default "__VITE_ASSET__hzVb4gFl__"